import type { NewArealplanInput } from '@origo/planregister';
import type { NewPlanFormValues } from '../types';

const DEFAULT_PLANSTATUS = '1';

// Smarte standardverdier: gjenbruk kommunenummer + lovreferanse fra forrige
// opprettelse i samme økt (som i legacy GAPR Admin). Modul-scope = lever så
// lenge appen er åpen.
let lastUsed: Pick<NewPlanFormValues, 'admomrkode' | 'lovreferanse'> | null = null;

export function rememberNewPlanDefaults(values: NewPlanFormValues): void {
    lastUsed = { admomrkode: values.admomrkode, lovreferanse: values.lovreferanse };
}

export function emptyNewPlanForm(): NewPlanFormValues {
    return {
        plannavn: '',
        plantype: '',
        planstatus: DEFAULT_PLANSTATUS,
        lovreferanse: lastUsed?.lovreferanse ?? '',
        saksnummer: '',
        admomrkode: lastUsed?.admomrkode ?? '',
        planId: '',
        forslagsstillerType: '',
        planbestemmelser: false,
    };
}

/** Skjema → `NewArealplanInput`. Tomme valgfrie kodefelt sendes som undefined. */
export function toNewArealplanInput(v: NewPlanFormValues): NewArealplanInput {
    return {
        plannavn: v.plannavn.trim(),
        plantype: v.plantype as NewArealplanInput['plantype'],
        planstatus: (v.planstatus || undefined) as NewArealplanInput['planstatus'],
        lovreferanse: v.lovreferanse as NewArealplanInput['lovreferanse'],
        saksnummer: v.saksnummer.trim(),
        admomrkode: v.admomrkode.trim(),
        planId: v.planId.trim(),
        forslagsstillerType: (v.forslagsstillerType || undefined) as NewArealplanInput['forslagsstillerType'],
        planbestemmelser: v.planbestemmelser,
    };
}
